import { Archive, Pencil, RotateCcw, Trash2 } from 'lucide-react';

/**
 * Boutons d'action de ligne pour les tables d'entités métier.
 * Conventions Standards Synotis :
 *  - icônes Lucide uniquement, jamais de texte brut
 *  - `title` systématique pour l'accessibilité
 *  - Modifier (Pencil) / Archiver (Archive) / Restaurer (RotateCcw vert)
 *  - `onDelete` (optionnel) : en vue archivée, affiche un bouton de suppression
 *    DÉFINITIVE (Trash2 rouge). Absent par défaut → pas de hard delete.
 */
const iconBtn = {
  background: 'transparent',
  border: '1px solid var(--glass-border)',
  borderRadius: 'var(--radius-sm)',
  padding: 6,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

export default function EntityActions({ archived, onEdit, onArchive, onRestore, onDelete }) {
  if (archived) {
    return (
      <div style={{ display: 'inline-flex', gap: 6 }}>
        <button
          type="button"
          onClick={onRestore}
          title="Restaurer"
          aria-label="Restaurer"
          style={{ ...iconBtn, color: 'var(--success)' }}
        >
          <RotateCcw size={14} />
        </button>
        {onDelete ? (
          <button
            type="button"
            onClick={onDelete}
            title="Supprimer définitivement"
            aria-label="Supprimer définitivement"
            style={{ ...iconBtn, color: 'var(--danger)' }}
          >
            <Trash2 size={14} />
          </button>
        ) : null}
      </div>
    );
  }
  return (
    <div style={{ display: 'inline-flex', gap: 6 }}>
      <button
        type="button"
        onClick={onEdit}
        title="Modifier"
        aria-label="Modifier"
        style={{ ...iconBtn, color: 'var(--text)' }}
      >
        <Pencil size={14} />
      </button>
      <button
        type="button"
        onClick={onArchive}
        title="Archiver"
        aria-label="Archiver"
        style={{ ...iconBtn, color: 'var(--warning)' }}
      >
        <Archive size={14} />
      </button>
    </div>
  );
}
